<template>
    <div>
        <h5 v-if="!emailsWrong.length && !noEmails.length && !emailsValid.length" class="text-center">
            Aucun prestataire n'a été sélectionné pour être ajouté dans votre veille.
        </h5>

        <v-expansion-panels v-model="panel" mandatory>
            <v-expansion-panel v-if="emailsWrong.length">
                <v-expansion-panel-header>
                    <div class="table-title">
                        <h3>E-mails invalides
                            <v-tooltip right>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-on="on">help</v-icon>
                                </template>
                                <span>
                                    Les prestataires ayant un e-mail invalide ne seront pas inclus dans la veille.
                                    Merci de corriger l'email ou de le supprimer.
                                </span>
                            </v-tooltip>
                            <div class="badge bg-error text-white ml-2">{{
                                    emailsWrong.length
                                }}
                            </div>
                        </h3>
                    </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-simple-table class="border">
                        <thead>
                        <tr>
                            <th class="text-left">Nom</th>
                            <th class="text-left">Catégorie</th>
                            <th class="text-left">{{ cityWording }}</th>
                            <th class="text-left">Destinataire</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="provider in emailsWrong" :key="provider.id">
                            <td>{{ provider.name }}</td>
                            <td>{{ provider.category }}</td>
                            <td>{{ provider.commune }}</td>
                            <td>
                                <span v-if="provider.email !== null">{{ provider.email }}</span>
                                <v-tooltip bottom v-if="selectedApidaeSelection === null">
                                    <template v-slot:activator="{ on }">
                                        <v-btn v-on="on" icon @click="editContact(provider)">
                                            <v-icon color="primary">edit</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Modifier l'email destinataire</span>
                                </v-tooltip>
                            </td>
                        </tr>
                        </tbody>
                    </v-simple-table>
                </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel v-if="noEmails.length">
                <v-expansion-panel-header>
                    <div class="table-title">
                        <h3>E-mails non renseignés
                            <v-tooltip right>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-on="on">help</v-icon>
                                </template>
                                <span>
                                       Les prestataires seront inclus dans la veille et ne seront pas notifiés par e-mail
                                        quand un changement d'information est détecté.
                                    </span>
                            </v-tooltip>
                            <div class="badge bg-success text-white ml-2">{{
                                    noEmails.length
                                }}
                            </div>
                        </h3>
                    </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-simple-table class="border">
                        <thead>
                        <tr>
                            <th class="text-left">Nom</th>
                            <th class="text-left">Catégorie</th>
                            <th class="text-left">{{ cityWording }}</th>
                            <th class="text-left">Destinataire</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="provider in noEmails" :key="provider.id">
                            <td>{{ provider.name }}</td>
                            <td>{{ provider.category }}</td>
                            <td>{{ provider.commune }}</td>
                            <td>
                                <span v-if="provider.email !== null">{{ provider.email }}</span>
                                <v-tooltip bottom v-if="selectedApidaeSelection === null">
                                    <template v-slot:activator="{ on }">
                                        <v-btn v-on="on" icon @click="editContact(provider)">
                                            <v-icon color="primary">edit</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Modifier l'email destinataire</span>
                                </v-tooltip>
                            </td>
                        </tr>
                        </tbody>
                    </v-simple-table>
                </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel v-if="emailsValid.length">
                <v-expansion-panel-header>
                    <div class="table-title">
                        <h3>E-mails valides
                            <div class="badge bg-success text-white">{{
                                    emailsValid.length
                                }}
                            </div>
                        </h3>
                    </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-simple-table class="border" fixed-header height="50vh">
                        <thead>
                        <tr>
                            <th class="text-left">Nom</th>
                            <th class="text-left">Catégorie</th>
                            <th class="text-left">{{ cityWording }}</th>
                            <th class="text-left">Destinataire</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="provider in emailsValid" :key="provider.id">
                            <td>{{ provider.name }}</td>
                            <td>{{ provider.category }}</td>
                            <td>{{provider.commune}}</td>
                            <td>
                                    <span v-if="provider.email !== null">
                                        {{ provider.email }}
                                    </span>
                            </td>
                        </tr>
                        </tbody>
                    </v-simple-table>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <div class="text-right mb-5 mt-5">
            <v-btn v-if="providersToAdd.length" class="default-button"
                   @click="setAddProStep(parseInt(addProStep) + 1)">Passer à l'étape suivante
            </v-btn>
        </div>

        <update-receiver-modale :edit-contact-modal="editModal" :selected-contact="selectedContact"
                                :selected-provider="currentProvider">
        </update-receiver-modale>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"
import UpdateReceiverModale from "../../provider/UpdateReceiverModale.vue"
import * as EmailValidator from "email-validator"

export default {
    name: "VtcEmailVerification",
    components: { UpdateReceiverModale },
    data() {
        return {
            panel: [0],
            currentProvider: null,
            editModal: false,
            selectedContact: null,
            cityWording: "Commune",
        }
    },
    methods: {
        ...mapMutations("vtc", ["setAddProStep",
            "setProviderToAddByIndex",
            "setEmailsValid",
            "setEmailsWrong",
            'setNoEmails',
            'setProvidersReadyToImport',
        ]),
        editContact(provider) {
            this.currentProvider = provider
            this.selectedContact = provider.email !== undefined ? provider.email : null
            this.editModal = true
        },
        updateProvider(provider) {
            this.providersToAdd.forEach((_provider, index) => {
                if (provider.id === _provider.id) {
                    let p = {
                        id: provider.id,
                        email: provider.contact.email,
                        category: provider.last_version.category.label,
                        commune: provider.last_version.localisation.commune.name,
                        name: provider.last_version.name,
                    }

                    this.setProviderToAddByIndex([index, p])
                    this.setEmailLists()
                }
            })
        },
        setEmailLists() {
            let emailsValid = []
            let emailsWrong = []
            let noEmails = []

            this.providersToAdd.forEach(provider => {
                if (provider.email === null) {
                    provider.error = "Email non renseigné"
                    noEmails.push(provider)
                } else if (!EmailValidator.validate(provider.email)) {
                    provider.error = "Mauvais format d'email"
                    emailsWrong.push(provider)
                } else {
                    emailsValid.push(provider)
                }
            })

            this.setEmailsValid(emailsValid)
            this.setEmailsWrong(emailsWrong)
            this.setNoEmails(noEmails)
            this.setProvidersReadyToImport(emailsValid.concat(noEmails))
        },
    },
    computed: {
        ...mapState("vtc", [
            "emailsValid",
            "emailsWrong",
            'noEmails',
            "addProStep",
            "providersToAdd",
            "selectedApidaeSelection"]),
        ...mapState("account", [
            "account",
        ]),
    },
    watch: {
        providersToAdd() {
            this.setEmailLists()
        },
    },
    created() {
        this.$global.$on("close-update-modal", () => {
            this.editModal = false
        })

        this.$global.$on("load-providers", (provider) => {
            this.updateProvider(provider)
        })

        if (this.account.configurations.quebec) {
            this.cityWording = "Municipalité"
        }
    },
    beforeDestroy() {
        this.$global.$off("close-update-modal")
        this.$global.$off("load-providers")
    },
}
</script>
